module.exports = __webpack_public_path__ + "static/media/facebook.ebf61c2c.svg";